import BlockOutsService from "external-services/blockouts-service/blockouts.service";
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import store from 'appRoot/Store';
import {scheduleActions, setSelectedSchedule} from 'app/reducers/schedule/slice';
import DateUtilsService from 'external-services/date-utils-service';
import { LocaleService } from 'internal-services/locale/locale.service';

const NS = 'BlockoutsListCtrl'; // jshint ignore:line

export default function BlockoutsListCtrl(
  $mdDialog, $state, $filter, $log, dateFor, schedule, appConstants
) {
  "ngInject";

  const vm = this;

  //-- define public properites
  vm.schedule = schedule;
  vm.repeatTypes = appConstants.Blockout.RepeatTypes;
  //-- define public methods
  vm.cancel = cancel;
  vm.setTimeByService = setTimeByService;
  vm.deleteBlockout = deleteBlockout;
  vm.deleteHidingService = deleteHidingService;
  vm.addExcludedDate = addExcludedDate;
  vm.edit = edit;
  vm.formatDates = (...args) => BlockOutsService.formatDates(...args);
  vm.blockoutToDelete = null;
  vm.handleDeleteConfirmed = handleDeleteConfirmed;
  vm.handleDeleteHidingServiceConfirmed = handleDeleteHidingServiceConfirmed;
  vm.handleDeleteCancelled = handleDeleteCancelled;
  vm.staffNameRequired = false;

  getBlockouts();

  function getBlockouts() {
    store.dispatch(setSelectedSchedule({ useCachedScheduleLookup: false }));
    BlockOutsService.getBlockoutsOnDate(dateFor).then(function (blockouts) {
      vm.blockouts = blockouts;
      getGeneralSettings();
    }).catch(function (err) {
      $log.error('Blockouts failed to load', err);
    });
    if (vm.schedule?.services?.length) {
      const dateStr = DateUtilsService.dateToDateStr(dateFor);
      BlockOutsService.getHiddenServiceByDate(dateStr).then(function (dto) {
        store.dispatch(scheduleActions.setHiddenServices(dto.serviceIds));
        vm.hidingServices = dto.serviceIds.map((id) => {
          return vm.schedule.services.find((service) => service._id === id);
        }).filter((service) => !!service).map((service) => {
          return {
            name: service.name,
            id: service._id,
            date: dateStr,
          };
        });
      });
    }

  }

  function setTimeByService(service) {
    vm.blockout.startDateTime = service.startTime;
    vm.blockout.endDateTime = service.endTime;
  }

  function cancel() {
    $mdDialog.hide();
  }

  function getGeneralSettings()
  {
    GeneralSettingsService.get().then(function (settings) {

      if(settings.staffRequiredEditBlockout)
      {
          vm.staffNameRequired = settings.staffRequiredEditBlockout;
      }

    });
  }

    function addExcludedDate(evt, blockout) {
       var confirm = $mdDialog.confirm()
         .parent(angular.element(document.body))
         .title('Add Excluded Date')
         .content('Remove blockout from ' + LocaleService.formatDate(dateFor, 'weekday-medium'))
         .ariaLabel('Add Excluded Date')
         .ok('Yes')
         .cancel('No')
         .targetEvent(evt);
       $mdDialog.show(confirm).then(function () {
         blockout.excludedDates.push(dateFor);
         BlockOutsService.save(blockout);
         console.log("[BLOCKOUT UPDATE] - Saving changes");
       });

    }

    function deleteBlockout(evt, blockout) {
      vm.blockoutToDelete = blockout;
    vm.errorMessage = 'Delete blockout ' + blockout.name;
    vm.showDeleteConfirmation = true;
    }
  function handleDeleteHidingServiceConfirmed(evt) {
    vm.showDeleteHidingServiceConfirmation = false;
    BlockOutsService.deleteHiddenService({
      serviceIds: [vm.hidingServiceToDelete.id],
      date: vm.hidingServiceToDelete.date,
    }).then(function () {
      getBlockouts();
    });
  }
  function deleteHidingService(evt, service) {
    vm.errorMessage = 'Delete hidden service ' + service.name;
    vm.showDeleteHidingServiceConfirmation = true;
    vm.hidingServiceToDelete = service;
  }

    function handleDeleteConfirmed(staffName)
    {
      vm.showDeleteConfirmation = false ;
      // Removing Manju Changes done related to ChangeLog feature - NBI-4368-Removing-manju-changelog
      // var blockoutChanges = populateLoggingObjectForDelete(vm.blockoutToDelete);

      BlockOutsService.remove(vm.blockoutToDelete).then(function () {

        // Removing Manju Changes done related to ChangeLog feature - NBI-4368-Removing-manju-changelog
        // ChangeLoggerService.save(blockoutChanges, 'changelog_blockouts', staffName, vm.blockoutToDelete.name);

        getBlockouts();
      });
    }

    function handleDeleteCancelled()
    {
      vm.showDeleteConfirmation = false ;
      vm.showDeleteHidingServiceConfirmation = false;
    }

  function edit(blockout) {
    $state.go('settings.blockouts.edit', {
      id: encodeURIComponent(blockout._id)
    });
    $mdDialog.hide();
  }

  // Removing Manju Changes done related to ChangeLog feature - NBI-4368-Removing-manju-changelog
  // function populateLoggingObjectForDelete(blockout)
  // {
  //   let modifiedValue = [];
  //
  //   modifiedValue.push(
  //     {
  //       property: 'Blockout',
  //       originalValue: blockout.name,
  //       newValue: '',
  //       operation: ChangeLogOperation.DeleteData
  //     }
  //   );
  //
  //   if (blockout.startDate) {
  //     modifiedValue.push(
  //       {
  //         property: 'startDate',
  //         originalValue: moment(blockout.startDate).format('DD MMM YY h:mma'),
  //         newValue: '',
  //         operation: ChangeLogOperation.DeleteData
  //       }
  //     );
  //   }
  //   else if (blockout.startDateTime) {
  //     modifiedValue.push(
  //       {
  //         property: 'startDate',
  //         originalValue: moment(blockout.startDateTime).format('DD MMM YY h:mma'),
  //         newValue: '',
  //         operation: ChangeLogOperation.DeleteData
  //       }
  //     );
  //   }
  //
  //   if (blockout.endDate) {
  //     modifiedValue.push(
  //       {
  //         property: 'endDate',
  //         originalValue: moment(blockout.endDate).format('DD MMM YY h:mma'),
  //         newValue: '',
  //         operation: ChangeLogOperation.DeleteData
  //       }
  //     );
  //   }
  //   else if (blockout.endDateTime) {
  //     modifiedValue.push(
  //       {
  //         property: 'endDate',
  //         originalValue: moment(blockout.endDateTime).format('DD MMM YY h:mma'),
  //         newValue: '',
  //         operation: ChangeLogOperation.DeleteData
  //       }
  //     );
  //   }
  //
  //   return modifiedValue;
  // }
}
